import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/components/AuthProvider";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  // CRITICAL: useRef synchronous flag to prevent StrictMode double-run
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data.user);
        // Clear hash
        window.history.replaceState(null, "", window.location.pathname);
        // Honor any saved redirect (e.g. /share/:token) before defaulting to /
        const next = sessionStorage.getItem("post_login_redirect");
        sessionStorage.removeItem("post_login_redirect");
        navigate(next || "/", { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="h-screen w-full flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-blue-500 mx-auto" />
        <p className="mt-4 text-sm text-muted-foreground">Conectando con tu cuenta…</p>
      </div>
    </div>
  );
}
